<template>
  <div>
    <vxe-grid
      ref="itemTable"
      auto-resize
      highlight-hover-row
      size="small"
      :data="tableData"
      :columns="tableColumns"
      :height="'300px'"
    >
      <template v-slot:tskInfoNo="{ row }">
        <div>
          {{ row.tskInfoNo }}
          <br />
          <div style="width: 235px;">
            <TskText :content="row.tskOverview">
              <el-link
                :ref="'link'"
                v-if="row.tskOverview"
                :underline="false"
                type="primary"
                @click="
                  openEditPage({
                    pageType: 'detail',
                    params: { code: row.tskInfoCode },
                    query: { tskInfoNo: row.tskInfoNo },
                  })
                "
              >
                {{ row.tskOverview }}
              </el-link>
            </TskText>
          </div>
        </div>
      </template>
      <template v-slot:tskByName="{ row }">
        <div>
          <div>
            {{ row.tskByName }}
          </div>
          <el-tag
            size="mini"
            :type="
              row.tskStatus == 'N'
                ? 'info'
                : row.tskStatus == 'P'
                ? ''
                : row.tskStatus == 'U'
                ? 'warning'
                : row.tskStatus == 'C'
                ? 'success'
                : row.tskStatus == 'Y'
                ? 'success'
                : 'danger'
            "
          >
            {{ row.v_tskStatus }}
          </el-tag>
        </div>
      </template>
      <template v-slot:empty="{}">
        <div style="text-align: center">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data mt-2">
            {{ $l('INDEX.tips_no_data') || '暂无数据！' }}
          </p>
        </div>
      </template>
    </vxe-grid>
  </div>
</template>
<script>
import tableColumns from './table-columns'
import TskText from '../collapse/tsk-text.vue'
export default {
  components: { TskText },
  props: {
    disabled: { type: Boolean, default: false },
    parentTskCode: { type: String, default: '' },
    tableData: { type: Array, default: () => [] },
  },
  data() {
    return {
      tableColumns: tableColumns(this),
    }
  },
  mounted() {},
  methods: {
    openEditPage({ pageType, params = {}, query = {} }) {
      this.$router.push({
        name: 'personal-taskCenter-detail',
        params: { ...params, pageType },
        query,
      })
    },
  },
}
</script>
<style lang="scss" scoped>
.el-link::v-deep:hover {
  text-decoration: none;
}
::v-deep {
  .el-link {
    display: inline;
  }
}
</style>
